export default {
    en: {
        id: 'exercise4',
        title: 'Telecom’s billing system must be designed to be useful to all parties',
        titles: ['Meet outside customer needs', 'Satisfy internal management requirements', 'Conform to outside regulations'],
        answers: [
            {
                title: 'Have a problem'
            },
            {
                title: 'Know the solution'
            },
            {
                title: 'How implement?'
            }
        ],
        boxes: [
            {
                name: 'box1',
                title: 'Time',
            },
            {
                name: 'box2',
                title: 'Structure',
            },
            {
                name: 'box3',
                title: 'Degree',
            }
        ],
        correctAnswers: {
            box1: true,
            box2: false,
            box3: false
        },
        userAnswers: {
            box1: false,
            box2: false,
            box3: false
        },
        text: 'This is another example of time order.  The billing system must have all three components (produce figures for management, produce figures for the customer, produce figures for the regulators), but the design should reflect consideration of what’s easiest for the customer before thinking about the other users.'
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/exercise4.js